import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getCargoById } from "../api/cargoApi";

const CargoDetail = () => {

  const { id } = useParams();
  const [company, setCompany] = useState(null);

  useEffect(() => {
    getCargoById(id).then((res) => {
      setCompany(res);
    });
  }, [id]);

  if (!company) return <p style={{ color: "white" }}>Loading...</p>;

  return (
    <div className="container mt-5" style={{ background: "white", padding: 40, borderRadius: 6 }}>

      <h2 className="mb-4">{company.companyName}</h2>

      <p><b>Contact Person:</b> {company.contactPerson}</p>
      <p><b>Email:</b> {company.email}</p>
      <p><b>Website:</b> {company.website}</p>
      <p><b>Mobile:</b> {company.mobile}</p>

      <p><b>District:</b> {company.district}</p>
      <p><b>Municipality:</b> {company.municipality}</p>
      <p><b>Local Area:</b> {company.localArea}</p>

      <p><b>Destination District:</b> {company.destinationDistrict}</p>
      <p><b>Destination Municipality:</b> {company.destinationMunicipality}</p>
      <p><b>Destination Area:</b> {company.destinationLocalArea}</p>

      <p><b>Service Area:</b> {company.serviceArea}</p>
      <p><b>Service Type:</b> {company.courierService}</p>
      <p><b>Transport:</b> {company.transportType}</p>

      <p><b>Available Space:</b> {company.availableSpace}</p>
      <p><b>Item Quota:</b> {company.itemQuota}</p>

      <p><b>Length:</b> {company.length}</p>
      <p><b>Breadth:</b> {company.breadth}</p>
      <p><b>Height:</b> {company.height}</p>

      <p><b>Price per KG:</b> {company.pricePerKg}</p>
      <p><b>Price per Item:</b> {company.pricePerItem}</p>
      <p><b>Price Whole Space:</b> {company.priceWholeSpace}</p>

      <p><b>Depart Time:</b> {company.departTime}</p>
      <p><b>Delivery Time:</b> {company.deliveryTime}</p>

    </div>
  );
};

export default CargoDetail;